import { ReactComponent as FilterSlider } from 'assets/icons/icon-filter-slider.svg';

export default FilterSlider;
